import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const SectionBasicInfoComponent = ({ onInnerBasicFormChange, selectedSections }: any) => (

    <><AccordionContainer
        child={
            <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                <InputContainer
                    label="Name"
                    name="Name"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'Name'

                        )
                    }}
                    type="text"
                    value={selectedSections?.Name}
                />
                <div className='col-span-full'>
                    <InputContainer
                        label="Description"
                        name="Description"
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'Description'

                            )
                        }}
                        type="text"
                        value={selectedSections?.Description}
                    />
                </div>


            </div>
        }
        expandedPanel="Basic Info"
        headerTitle="Basic Info"
    />
    </>

)
export default SectionBasicInfoComponent;
